/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, coloredScrollBar, disable } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// DROPDOWN FILTER
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	dropdownfilter: {
		position: 'relative',
		minWidth: pxToEm(210),
		maxWidth: pxToEm(275),
		height:pxToEm(56),
		zIndex: 1,
		'& .name-menuItems':{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
			padding: replacePXinStringWithEM('10px'),
			backgroundColor: theme.color.light.light.swatch,
			boxShadow: theme.boxShadow.small,
			'& .all-items':{
				fontSize: pxToEm(14),
				color: theme.color.neutral.dark.swatch,
				margin: replacePXinStringWithEM('15px 0'),
				'&:hover':{
					cursor: 'pointer'
				}
			},
			'& .items':{
					height: pxToEm(220),
					overflow: 'scroll',
					overflowX: 'hidden',
					extend: coloredScrollBar(theme.color.primary.medium.swatch),
			},
			'& .button':{
				margin: replacePXinStringWithEM(`8px 0 0`)
			},
            '&.active-true': {
               	height: 'auto',
            	maxHeight: pxToEm(428),
				overflow: 'hidden',
                transition: 'all .15s'
            },
            '&.active-false': {
                height: pxToEm(0),
				padding: 0,
                overflow: 'hidden',
                transition: 'all .15s',
				pointerEvents: 'none',
				opacity: 0
            }
		},
		'& .button.name-filter':{
			width: '100%'
		},
		'&.disabled-true':{
			extend: disable
		}
	}
});